import * as React from 'react';

import BaseSettingsTeamLayout from './BaseSettingsTeamLayout';

export default function (params) {
  return BaseSettingsTeamLayout();
};
